export default __webpack_public_path__ + "static/deep-dive-mobile-9f0c71038935588a979f47fc2f2ef358.webp";